import React from "react";

export const DocTypeContext = React.createContext<{
    docType: string;
    setDocType: React.Dispatch<React.SetStateAction<string>>;
}>({ docType: "uk_gt5", setDocType: () => null });

